import { render, staticRenderFns } from "./video-element.vue?vue&type=template&id=26b5ea00&"
import script from "./video-element.vue?vue&type=script&lang=js&"
export * from "./video-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports